import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BlocksRoutingModule } from './blocks-routing.module';
import { HomeComponent } from './home/home.component';
import { MenuComponent } from './menu/top-menu/top-menu.component';
import { AppComponent } from './root/app.component';
import { SharedModule } from '../shared/shared/shared.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AuthorizedContainerComponent } from './authorized-container/authorized-container.component';
import { AnynoumouseContainerComponent } from './anynoumouse-container/anynoumouse-container.component';
import { SideMenuComponent } from './menu/side-menu/side-menu.component';


@NgModule({
  declarations: [
    HomeComponent,
    MenuComponent,
    AppComponent,
    AuthorizedContainerComponent,
    AnynoumouseContainerComponent,
    SideMenuComponent,
  ],
  imports: [
    SharedModule,
    BlocksRoutingModule,
    NgxSpinnerModule.forRoot({
      type: 'ball-scale-multiple',
    }),
  ],
  exports:[AppComponent]
})
export class BlocksModule { }
